export default "__VITE_ASSET__CnPwSfDu__"